module.exports = __webpack_public_path__ + "src/app/_content/MOTFonts/BMWMotorradW01-Bold.woff?cbf4d4bfc80c40230ed7734ef0c37e26";